import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIdPath = returnPath("/templates/runsheet-styles/:id");
export const getIndexPath = returnPath("/templates/runsheet-styles");
